module.exports = __webpack_public_path__ + "img/ppc.18a0593a.svg";